var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#6638A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6645 12.671C22.3956 11.0841 25.7525 11.1118 28.458 12.7436C31.1368 14.4086 32.765 17.3802 32.7498 20.5768C32.6874 23.7524 30.9416 26.7375 28.7593 29.0451C27.4998 30.383 26.0908 31.566 24.5611 32.57C24.4035 32.6611 24.2309 32.7221 24.0519 32.75C23.8795 32.7427 23.7116 32.6917 23.5634 32.6018C21.228 31.0932 19.1792 29.1675 17.5154 26.9175C16.1232 25.0392 15.3323 22.77 15.25 20.418C15.2482 17.2153 16.9335 14.2578 19.6645 12.671ZM21.2427 21.7434C21.7021 22.876 22.7865 23.6147 23.9895 23.6147C24.7776 23.6204 25.5352 23.3047 26.0935 22.738C26.6518 22.1713 26.9643 21.4007 26.9616 20.5979C26.9658 19.3725 26.2443 18.2653 25.1341 17.7934C24.0238 17.3215 22.7438 17.5779 21.8916 18.4429C21.0395 19.3079 20.7833 20.6108 21.2427 21.7434Z",
    fill: "#6638A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 36.5C27.4518 36.5 30.25 35.9404 30.25 35.25C30.25 34.5596 27.4518 34 24 34C20.5482 34 17.75 34.5596 17.75 35.25C17.75 35.9404 20.5482 36.5 24 36.5Z",
    fill: "#6638A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLocation);
export default __webpack_public_path__ + "static/media/event-location.5d0bf30bc44c5633c2994a538af99522.svg";
export { ForwardRef as ReactComponent };